"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = mapTable;
const jsx_runtime_1 = require("react/jsx-runtime");
const sylex_1 = require("@leshen/gatsby-theme-leshen/sylex");
const mapRichText_1 = require("./mapRichText");
function mapTable({ data, mappers, packages = {}, key, }) {
    if (!data?.children)
        return (0, jsx_runtime_1.jsx)("div", {});
    const [firstRow, ...bodyRows] = data.children;
    const isHeaderRow = firstRow &&
        firstRow.children?.every((cell) => cell.headerState === 1 || cell.headerState === 3);
    function renderCell(cell, i, as = 'td', key) {
        const Tag = as;
        return ((0, jsx_runtime_1.jsx)(Tag, { children: cell.children.map((item, j) => {
                if (!item)
                    return null;
                if (item.type === 'block') {
                    return mappers.mapBlock({
                        block: item.fields,
                        mappers,
                        packages,
                    });
                }
                return ((0, jsx_runtime_1.jsx)("div", { children: item.children.map((textNode, k) => {
                        if (textNode.type === 'inlineBlock') {
                            return mappers.mapBlock({
                                block: textNode.fields,
                                mappers,
                                packages,
                            });
                        }
                        return (0, mapRichText_1.mapText)(textNode, mappers);
                        // return <span key={`text-${k}`}>{textNode.text}</span>
                    }) }, `${key}-para-${j}`));
            }) }, `${key}-${as}-${i}`));
    }
    const rows = isHeaderRow ? bodyRows : data.children;
    return ((0, jsx_runtime_1.jsx)(sylex_1.SylexTable, { children: (0, jsx_runtime_1.jsxs)("table", { children: [isHeaderRow && ((0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsx)("tr", { children: firstRow?.children &&
                            firstRow.children.map((cell, i) => renderCell(cell, i, 'th', key)) }) })), (0, jsx_runtime_1.jsx)("tbody", { children: rows.map((row, rowIdx) => ((0, jsx_runtime_1.jsx)("tr", { children: row.children.map((cell, cellIdx) => renderCell(cell, cellIdx, 'td', key)) }, rowIdx))) })] }) }, key));
}
